<template>
  <div class="app-wrapper">
    <div id="header" v-show="!full_screen">
      <private-header />
    </div>
    <div class="main-container">
      <div class="sidebar" v-show="!full_screen">
        <navbar />
      </div>
      <div id="main-container">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
        <!-- <router-view /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PrivateHeader from './components'
import Navbar from './components/Navbar'
export default {
  components: {
    PrivateHeader,
    Navbar
  },
  computed: {
    ...mapGetters(['full_screen']),
    key () {
      return this.$route.path
    }
  }
}
</script>

<style lang="less" scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  #header {
    background: #353940;
    line-height: 74px;
    height: 74px;
    padding: 0 20px;
  }
  .main-container {
    display: flex;
    flex: 1;
    min-height: 0;
  }
  .sidebar {
    background: #2a2d34;
    width: 180px;
    overflow: auto;
  }
  #main-container {
    flex: 1;
    min-width: 0;
  }
}
</style>
